import Vue from 'vue';
import VueI18n from 'vue-i18n';
import locale from 'element-ui/lib/locale';
Vue.use(VueI18n);

// 引入自定义的语言配置文件
import zh_CN from './zh_CN';
import en_US from './en_US';
import tr_TR from './tr_TR';
import ru_RU from './ru_RU';

// import message from './children/message.json';

// 引入element-ui的多语言配置
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import enLocale from 'element-ui/lib/locale/lang/en';
import trLocale from 'element-ui/lib/locale/lang/tr-TR';
import ruLocale from 'element-ui/lib/locale/lang/ru-RU';

const messages = {
	en_US: {
		...en_US,
		...enLocale,
	},
	zh_CN: {
		...zh_CN,
		...zhLocale,
	},
	tr_TR: {
		...tr_TR,
		...trLocale,
	},
	ru_RU: {
		...ru_RU,
		...ruLocale,
	}
};
// 从URL域名获取语言
function getLanguageFromUrl() {
	const hostname = window.location.hostname;
	
	// 检查是否包含turkey字样，即为土耳其语
	if (hostname.includes('turkey')) {
		return 'tr_TR';
	}
	
	// 检查是否包含en字样，默认为英语
	if (hostname.includes('www')) {
		return 'en_US';
	}
	
	// 检查是否包含www或cn字样，默认为中文
	if (hostname.includes('cn.e99')) {
		return 'zh_CN';
	}

	// 检查是否包含ru字样，默认为俄语
	if (hostname.includes('russian')) {
		return 'ru_RU';
	}
	
	// 本地开发环境，从localStorage获取
	if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.includes('192.168.')) {
		let val = localStorage.getItem('locale');
		if (val == 'zh') {
			val = 'zh_CN';
		} else if (val == 'en') {
			val = 'en_US';
		} else if (val == 'tr') {
			val = 'tr_TR';
		} else if (val == 'ru') {
			val = 'ru_RU';
		}
		return val || 'en_US';
	}
	
	// 默认返回英语
	return 'en_US';
}

const currentLanguage = getLanguageFromUrl();

// 创建vue-i18n实例
const i18n = new VueI18n({
	locale: currentLanguage,
	messages: messages,
});

// 添加语言判断辅助函数
Vue.prototype.$isEnglish = function() {
	return this.$i18n.locale === 'en_US' || this.$i18n.locale === 'en';
};

Vue.prototype.$isChinese = function() {
	return this.$i18n.locale === 'zh_CN' || this.$i18n.locale === 'zh';
};

Vue.prototype.$isTurkish = function() {
	return this.$i18n.locale === 'tr_TR' || this.$i18n.locale === 'tr';
};

Vue.prototype.$isRussian = function() {
	return this.$i18n.locale === 'ru_RU' || this.$i18n.locale === 'ru';
};

// turkey.e99.cn
// www.e99.cn
locale.i18n((key, value) => i18n.t(key, value));

export { i18n };